module.exports = __webpack_public_path__ + "assets/fonts/glyphicons-halflings-regular.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./~/bootstrap/dist/fonts/glyphicons-halflings-regular.svg
 ** module id = 1090
 ** module chunks = 0
 **/